import { Injectable } from '@angular/core';
import { Query, gql } from 'apollo-angular';


import { StorefrontBasicFragment, StorefrontBasic } from './storefront-basic.fragment';

@Injectable({
  providedIn: 'root'
})
export class GetStorefrontGQL extends Query<GetStorefrontGQLResponse, GetStorefrontGQLVariables> {
  document = gql`
  query getStorefront($storefrontId: ID) {
    storefronts(storefrontIds: [$storefrontId]) {
      ...StorefrontBasic
    }
  }
  ${StorefrontBasicFragment}
  `;
}

interface GetStorefrontGQLVariables {
  storefrontId: string;
}

interface GetStorefrontGQLResponse {
  storefronts: StorefrontBasic[];
}


